
/*----------------------
OPEN BLOCK
---------------------- */
OpenBlock = {
    init: function () {
        if ($(window).width() > 1080) {
            $(".product-info__title").on("mouseenter", function () {
                var title = $(this).data("title");
                var child_this = $(".product-info__text-" + title);
                $('.product-info__text').not(child_this).removeClass('open');
                child_this.addClass("open");

                $('.product-info__title').not(this).removeClass('current');
                $(this).addClass("current");

            });

            $(".product-info__title").on("click", function () {
                var title = $(this).data("title");
                var child_this = $(".product-info__text-" + title);
                $('.product-info__text').not(child_this).removeClass('open');
                child_this.toggleClass("open");

                $('.product-info__title').not(this).removeClass('current');
                $(this).addClass("current");

            });
            $("body").on("click", function (e) {
                if (!$(e.target).closest('.product-info__title, .product-info__text').length) {
                    $('.product-info__text').removeClass('open');
                    $('.product-info__title').removeClass('current');
                }
            });

        } else {
            $(".product-info__title").on("click", function () {
                var title = $(this).data("title");
                var child_this = $(".product-info__text-" + title);
                $('.product-info__text').not(child_this).removeClass('open');
                child_this.toggleClass("open");

                $('.product-info__title').not(this).removeClass('current');
                $(this).toggleClass("current");

            });
            $("body").on("click", function (e) {
                if (!$(e.target).closest('.product-info__title, .product-info__text').length) {
                    $('.product-info__text').removeClass('open');
                    $('.product-info__title').removeClass('current');
                }
            });
        }
    }
};


$(document).ready(function () {
    OpenBlock.init();
});
$(document).on('shopify:section:load', function (event) {
    OpenBlock.init();
});